import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetLines } from '@/hooks/useGetLines';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';

const { useWatch } = Form;

export function LineFormItem() {
	const organization_id: string = useWatch('organization_id');
	const company_id: string = useWatch('company_id');
	const sector_id: string = useWatch('sector_id');

	const { isLoading, data: lines = [] } = useGetLines({
		organization_id,
		company_id,
		sector_id
	});

	return (
		<FormItemWrapper
			name="line_id"
			label={<LabelMediumRegular>{I18n.get('Line')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
		>
			<SelectOptions allowClear options={lines} placeholder={I18n.get('Line')} loading={isLoading} />
		</FormItemWrapper>
	);
}
